// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hand[data-v-98063c9a]:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
